/**
 * Standard envelope returned by every Clinio Edge Function.
 * Mirrors `_shared/errors.ts` on the server side.
 */
export type ApiSuccess<T> = { ok: true; data: T };
export type ApiError = {
  code:
    | 'unauthorized'
    | 'forbidden'
    | 'invalid-input'
    | 'not-found'
    | 'conflict'
    | 'rate-limited'
    | 'method-not-allowed'
    | 'stripe-not-configured'
    | 'stripe-not-onboarded'
    | 'clinio-pay-unavailable'
    | 'clinio-forms-unavailable'
    | 'missing-clinical-reason'
    | 'internal-error';
  message: string;
  details?: unknown;
};
export type ApiFailure = { ok: false; error: ApiError };
export type ApiResponse<T> = ApiSuccess<T> | ApiFailure;

export class ApiCallError extends Error {
  readonly code: ApiError['code'];
  readonly details?: unknown;
  constructor(error: ApiError) {
    super(error.message);
    this.code = error.code;
    this.details = error.details;
    this.name = 'ApiCallError';
  }
}
